import agent from './agent.json';
import knowledge_base from './knowledge-base.json';

export default {
  ai: {
    knowledge_base,
    agent,
  },
};
